<template>

    <invoices
        :project-uuid="project.uuid"
        :invoices-uri="route('api.v1.projects.invoices', {project_uuid:project.uuid})"
    ></invoices>

</template>

<script>

    import { mapGetters } from 'vuex';
    import Lang from '../../../Lang';
    import Invoices from "../../../components/Projects/Invoices";

    export default {

        components: {
            Invoices,
        },

        computed: {
            ...mapGetters([
                'getProject',
            ]),

            project() {
                return this.getProject;
            },
        },

        data() {
            return {
                Lang:Lang,
            }
        },

        metaInfo: {
            title:'Project facturen',
        },

        name:'ProjectsDetailsInvoices',

    }

</script>
